export default __webpack_public_path__ + "static/media/google-play-badge-med.e9d11267.jpg";